var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeadBar'),_c('HeadNav'),_c('div',{staticClass:"con"},[_c('div',{staticClass:"con-inner flex flex-row"},[_c('StandardFileList'),_c('RankLists')],1)]),_c('FootBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }